import { Check, Pencil, X } from 'lucide-react';

import { Textarea } from '@apps/web/components/ui/textarea';

type EditableMessageProps = {
    readonly label: string;
    readonly message: string;
    readonly editedMessage: string | null;
    readonly isEditing: boolean;
    readonly disabled?: boolean;
    readonly onEdit: () => void;
    readonly onSave: () => void;
    readonly onCancel: () => void;
    readonly onMessageChange: (value: string) => void;
};

export function EditableMessage({
    label,
    message,
    editedMessage,
    isEditing,
    disabled,
    onEdit,
    onSave,
    onCancel,
    onMessageChange,
}: EditableMessageProps) {
    return (
        <div className="border-border bg-background rounded border p-2">
            <div className="mb-1 flex items-center justify-between">
                <p className="text-xs font-medium">{label}</p>
                {isEditing ? (
                    <div className="flex items-center gap-2">
                        <button
                            type="button"
                            onClick={onSave}
                            className="text-muted-foreground hover:text-foreground flex items-center gap-1 text-xs"
                            disabled={disabled}
                        >
                            <Check className="h-3 w-3" />
                            Save
                        </button>
                        <button
                            type="button"
                            onClick={onCancel}
                            className="text-muted-foreground hover:text-foreground flex items-center gap-1 text-xs"
                            disabled={disabled}
                        >
                            <X className="h-3 w-3" />
                            Cancel
                        </button>
                    </div>
                ) : (
                    <button
                        type="button"
                        onClick={onEdit}
                        className="text-muted-foreground hover:text-foreground flex items-center gap-1 text-xs"
                        disabled={disabled}
                    >
                        <Pencil className="h-3 w-3" />
                        Edit
                    </button>
                )}
            </div>
            {isEditing ? (
                <Textarea
                    value={editedMessage ?? message}
                    onChange={(e) => onMessageChange(e.target.value)}
                    className="max-h-[200px] min-h-[80px] text-xs"
                    disabled={disabled}
                />
            ) : (
                <p className="text-xs whitespace-pre-wrap italic">
                    “{editedMessage ?? message}“
                </p>
            )}
        </div>
    );
}
